module.exports = __webpack_public_path__ + "img/locationDot_gray.b4feb8fb.svg";